export default "mutation GetAuthToken($username: String!, $password: String!) {\n  getAuthToken(\n    username: $username,\n    password: $password\n  )\n}\n"